
<template>
 <div class="HomePage">
  <div class="break"></div>
 <MarqueeText></MarqueeText>
   <div class="break"></div>
 <div ref="hero" class="Hero">
   <div class="MainPageText">
     <div class="TitleContainer">
       <h1 class="Title">Residential & Commercial Roofing Contractor </h1>
       <h2 class="subTitle">Based in Niles, proudly serving communities across the Great Lakes State</h2>
       <ul class="facts-list">
         <li>Locally Owned and Operated</li>
         <li>Licensed and insured for your protection</li>
         <li>Financing Options Available</li>
         <li>High-quality materials and workmanship</li>
         <li>Free estimates and competitive pricing</li>
         <li>Roofing repair services available</li>
         <li>Customer satisfaction guaranteed</li>
       </ul>
     </div>
     <div class="SubTitleContainer">
       <ContactForm :modal="this.modal"></ContactForm>  
     </div>
   </div>
   <div>
   <div v-if="showContactForm" class="floatingContact">
     <ContactForm :modal="this.modal"></ContactForm>
   </div>
 
 </div>
 </div>

   <!-- Main content wrapper with gradient background -->
   <div class="main-content-wrapper">
   <div class="break"></div>
   <div class="Services">
    <span class="ServicesTitle">Check out our Google Reviews!</span>
    <CustomerTestimonials/>
   </div>
   <div class="break"></div>
    <IdentityPage/>
   <div class="break"></div>
    <LicensedInsured/>
    <AwardsPage/>
  <div class="break"></div>
  <div class="Services">
   <span class="ServicesTitle">Services</span>
   <div class="serviceSelection">
     <PhotoCard v-for="(service, index) in services" :key="index"
     :Services="service" @click="goToPage(service.path)">
    </PhotoCard>
   </div>
   <div class="break"></div>
   <DonateCTA/>

 </div>
 <div class="break"></div>
 <div id="footer">
   <PageFooter/>
 </div>
 </div>
 <!-- End main content wrapper -->

 </div>
 </template>
 
 <script>
 import ContactForm from '@/components/ContactForm.vue';
 import PhotoCard from '@/components/NewServiceSelector.vue';
 import MarqueeText from '@/components/MarqueeText.vue';
 import PageFooter from '@/components/PageFooter.vue';
 import LicensedInsured from '@/components/LicensedInsured.vue';
 import IdentityPage from '@/components/IdentityPage.vue';
 import AwardsPage from '@/components/AwardsPage.vue';
 import CustomerTestimonials from '@/components/CustomerTestimonials.vue';
 import DonateCTA from '@/components/DonateCTA.vue';
 import { upsertJsonLd, removeJsonLd, BASE_URL, DEFAULT_IMAGE } from '@/utils/seo';
 
 export default {
   name: 'HomePage',
   created() {
     this.boundHandleScroll = this.handleScroll.bind(this);
   },
   data(){
     return{
       modal: false,
       services: [

       {
         imageSrc: require('@/assets/RoofingRepairPhoto.jpg'),
         title: 'Full Roof Replacements',
          path: '/roofing-projects',
       },

       {
         imageSrc: require('@/assets/FasciaSoffit/Roof1.jpg'),
         title: 'Fascia & Soffit',
         path: '/fascia-soffit',
       },

       {
         imageSrc: require('@/assets/Repairs/Repair1.jpg'),
         title: 'Roofing Repairs',
         path: '/repair-projects',
       },

     ],
     showContactForm: true,
     boundHandleScroll: null,
     }
   },
 
   components: {
     ContactForm,
     PhotoCard,
     PageFooter,
     LicensedInsured,
    CustomerTestimonials,
    IdentityPage,
    AwardsPage,
    MarqueeText,
    DonateCTA
   },
   mounted() {
     upsertJsonLd('home-local-business', {
       "@context": "https://schema.org",
       "@type": "RoofingContractor",
       "name": "Homes Roofing Co LLC",
       "@id": `${BASE_URL}/#roofing-contractor`,
       "image": DEFAULT_IMAGE,
       "logo": DEFAULT_IMAGE,
       "description": "Professional roofing contractor based in Niles and proudly serving communities across Michigan with roof replacement, repairs, fascia, soffit, gutters, and siding. 50-year warranty available.",
       "address": {
         "@type": "PostalAddress",
         "addressLocality": "Niles",
         "addressRegion": "MI",
         "addressCountry": "US"
       },
       "geo": {
         "@type": "GeoCoordinates",
         "latitude": "42.2917",
         "longitude": "-85.5872"
       },
       "telephone": "+1-269-262-5055",
       "email": "homesroofingllc@gmail.com",
       "url": BASE_URL,
       "priceRange": "$$$",
       "areaServed": [
         {
           "@type": "State",
           "name": "Michigan"
         },
         {
           "@type": "City",
           "name": "Gaylord",
           "containedInPlace": {
             "@type": "State",
             "name": "Michigan"
           }
         },
         {
           "@type": "City",
           "name": "Niles",
           "containedInPlace": {
             "@type": "State",
             "name": "Michigan"
           }
         }
       ],
       "serviceType": [
         "Roof Replacement",
         "Roof Repair",
         "Fascia Installation",
         "Soffit Installation",
         "Gutter Installation",
         "Siding Installation"
       ],
       "aggregateRating": {
         "@type": "AggregateRating",
         "ratingValue": "5",
         "reviewCount": "50"
       },
       "hasCredential": [
         "Master Craftsman Certified",
         "Shingle Master Certified",
         "EPA Lead-Safe Certified"
       ]
     });

     upsertJsonLd('home-website', {
       '@context': 'https://schema.org',
       '@type': 'WebSite',
       '@id': `${BASE_URL}/#website`,
       name: 'Homes Roofing Co',
       url: BASE_URL,
       description: 'Roof repair and roof replacement services across Michigan, including Gaylord and Niles.',
       potentialAction: {
         '@type': 'SearchAction',
         target: `${BASE_URL}/?q={search_term_string}`,
         'query-input': 'required name=search_term_string'
       }
     });
     
     // Add scroll listener
     console.log("mounted");
     window.addEventListener('scroll', this.boundHandleScroll);
   },
   beforeUnmount() {
     window.removeEventListener('scroll', this.boundHandleScroll);
     removeJsonLd('home-local-business');
     removeJsonLd('home-website');
   },
   methods: {
   handleScroll() {
    if (this.$refs.scrollElement) {
    // const scrollPosition = this.$refs.scrollElement.offsetHeight;
    // const heroHeight = this.$refs.hero.offsetHeight;
    this.showContactForm = true
  }

   },
   goToPage(path) {
      this.$router.push(path);
    },
 },

 }
 </script>
 
 <style>
   .HomePage {
    margin-top: 93px;
    background: linear-gradient(135deg, #002655 0%, #1a3a5c 50%, #4a7ba7 100%);
    color: #ffffff;
  }
  
  /* Main content wrapper with gradient background */
  .main-content-wrapper {
    background: linear-gradient(135deg, #002655 0%, #1a3a5c 50%, #4a7ba7 100%);
    width: 100%;
  }
  
  @media (max-width: 1024px) {
    .HomePage {
    margin-top: 168px;
  } 

 }

.Hero {
  @media (max-width: 1024px) {
    background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('../assets/Cover Roof Mobile.jpg');
  }
  @media (min-width: 1025px) {
    background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('../assets/Cover Roof.jpg');
  } 

 padding: 60px 30px;

 background-size: cover; /* Cover the entire .Hero area */
 background-position: center; /* Center the image */
 background-repeat: no-repeat; /* Do not repeat the image */
}



/* Desktop Specific */
@media (min-width: 1025px) {

 .MainPageText {
  height: 70vh;
  min-height: 500px;
  margin: 0 auto;
  max-width: 1080px;
  padding-top: 8%;
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
}

 /* Adjust for shorter screens */
 @media (max-height: 800px) {
   .MainPageText {
     height: auto;
     min-height: unset;
     padding-top: 5%;
     padding-bottom: 30px;
   }
   
   .Hero {
     padding: 30px 50px;
   }
 }

 .TitleContainer{
  display: flex;
  flex-direction: column;
  width: 80%;
  max-width: none;
  align-items: center;
  text-align: center;
  padding: 25px;
  background: rgba(255, 255, 255, 0.05);
  border-left: 5px solid #f1c40f;
  border-radius: 10px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.25);
 }

 .SubTitleContainer {
  width: 80%;
  max-width: none;
  align-self: center;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  background: transparent;
  border-left: none;
  border-radius: 0;
  box-shadow: none;
 }

 .SubTitleContainer :deep(.buttonList) {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;
 }

 .SubTitleContainer :deep(.contact-button),
 .SubTitleContainer :deep(.financing-button) {
  width: 100%;
  margin-right: 0;
  padding: 18px 28px;
  font-size: 1.35rem;
 }

 .facts-list {
  text-align: center !important;
  justify-items: stretch;
 }

 .facts-list li {
  justify-content: flex-start;
  text-align: left;
 }
 @media screen and (max-width: 1024px) {
   .TitleContainer{
    display: flex;
    flex-direction: column;
    align-items: center;
  }
 }
}

.SubTitleContainer {
   align-content: center;
 }

@media (max-width: 768px) {
  .MainPageText {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .TitleContainer {
    width: 100%;
    align-items: flex-start;
    text-align: left;
    padding: 18px;
  }

  .SubTitleContainer {
    width: 100%;
    order: 2;
  }

  .SubTitleContainer :deep(.buttonList) {
    width: 90vw;
    max-width: none;
    margin: 0 auto;
    align-items: center;
  }

  .SubTitleContainer :deep(.contact-button),
  .SubTitleContainer :deep(.financing-button) {
    width: 100%;
    margin-right: 0;
  }

}

@media (max-width: 1024px) {
  .MainPageText {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 16px;
    height: auto;
    min-height: unset;
  }

  .TitleContainer {
    width: 100%;
    align-items: flex-start;
    text-align: left;
  }

  .SubTitleContainer {
    width: 100%;
    order: 2;
  }

  .SubTitleContainer :deep(.buttonList) {
    width: 90vw;
    max-width: none;
    margin: 0 auto;
    align-items: center;
  }

  .SubTitleContainer :deep(.contact-button),
  .SubTitleContainer :deep(.financing-button) {
    width: 100%;
    margin-right: 0;
  }

}


.Title {
 font-size: 3em;
   letter-spacing: 0;
   text-shadow: 3px 3px 6px rgba(0, 0, 0, 0.7);
  color: #f1c40f;
   font-family: 'Roboto Slab', sans-serif;
}

@media (max-height: 800px) and (min-width: 1025px) {
  .Title {
    font-size: 28px;
    margin-bottom: 10px;
  }
  
  .subTitle {
    font-size: 1.2em !important;
    margin-bottom: 10px;
  }
}

.facts-list {
    list-style: none !important;
    display: grid !important;
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
    gap: 10px !important;
    width: 100% !important;
    max-width: 100% !important;
    margin: 10px 0 0 !important;
    padding: 0 !important;
    font-family: 'Roboto', sans-serif;
    text-align: left !important;
}

.facts-list li {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    padding: 12px 14px;
    background: rgba(255, 255, 255, 0.07);
    border-radius: 10px;
    border-left: 4px solid #f1c40f;
    color: #f5f5f5;
    font-size: clamp(0.8rem, 1.5vw + 0.3rem, 1rem);
    line-height: 1.5;
    margin-bottom: 0;
}

.facts-list li::before {
    content: "✓";
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 22px;
    height: 22px;
    min-width: 22px;
    border-radius: 50%;
    background: #f1c40f;
    color: #1a1a1a;
    font-size: 0.75rem;
    font-weight: 900;
    margin-top: 1px;
}


@media (max-width: 799px) {
  .facts-list {
    grid-template-columns: 1fr !important;
  }
}

.facts-list 

.subTitle {
 font-family: 'Roboto', sans-serif; /* Use Open Sans font */
 font-size: 1.5em; /* Increase font size */
 font-weight: bold; /* Make text bold */
 letter-spacing: 0.5px; /* Add some letter spacing */
 text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.55);
 color: #e8e8e8; /* White text */
}
 
.ServicesTitle{
 color: #f1c40f;
   text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
   letter-spacing: 1px;
   font-size: 2.2em;
   position: relative;
   z-index: 2;
   padding-bottom: 10px;
   border-bottom: 3px solid #f1c40f;
   display: inline-block;
}

.Bold{
 font-weight: bold;
}

.Services{
  max-width: 1080px;
  margin: 0 auto;
  padding: 30px;
   display: flex;
   flex-direction: column;
   background: transparent;
   text-align: center;
}


.Services .Title {
 width: 100%;
 display: flex;
 justify-content: center;
 padding: 15px;
 font-size: -webkit-xxx-large;
}
.serviceSelection {
 display: flex;
 justify-content: center;
 flex-direction: row;
 flex-wrap: wrap;
 gap: 20px;
 margin-top: 25px;
}

.photo-card {
   display: flex;
   flex-direction: column;
  color: #f5f5f5;
   justify-content: center;
   align-items: center;
}


.HomeImage{
 height: 100%;
 width: 100%;
 border-radius: 10px;
 object-fit: cover;

 @media (max-width: 1024px) {
   margin-bottom: 20px;

 }
}
.break{
 width: 100%;
 border-bottom: #f1c40f .2em solid;
}
.show-contact-form {
 position: fixed;
 bottom: 20px;
 right: 20px;
 display: block;
}
.floatingContact {

 .contact-button {

  position: fixed;
  bottom: max(16px, env(safe-area-inset-bottom));
  right: max(16px, env(safe-area-inset-right));
  background: linear-gradient(145deg, #a10d10 0%, #d3181c 100%);
  color: white;
  border: 2px solid rgba(241, 196, 15, 0.95);
  border-radius: 999px;
  min-width: 176px;
  max-width: 220px;
  height: 56px;
  padding: 0 18px;
  text-align: center;
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.95rem;
  font-weight: 800;
  letter-spacing: 0.35px;
  text-transform: uppercase;
  line-height: 1;
  white-space: nowrap;
  gap: 0;
  cursor: pointer;
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.4), 0 0 0 0 rgba(241, 196, 15, 0.55);
  transition: transform 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
  animation: ctaAttention 5.5s cubic-bezier(0.4, 0, 0.2, 1) infinite;
  z-index: 100;

   @media (max-width: 500px){
    min-width: 160px;
    height: 52px;
    font-size: 0.86rem;
    padding: 0 14px;
   }
  }

  .financing-button {
    display : none;
}
}
.subTitle {
 font-family: 'Roboto', sans-serif; /* Use Open Sans font */
 font-size: 1.5em; /* Increase font size */
 font-weight: bold; /* Make text bold */
 letter-spacing: 0.5px; /* Add some letter spacing */
 text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.55);
 color: #e8e8e8; /* White text */
}

.floatingContact .contact-button:hover {
  transform: translateY(-2px);
  background: linear-gradient(145deg, #b41013 0%, #e01f24 100%);
  box-shadow: 0 14px 28px rgba(0, 0, 0, 0.45), 0 0 0 6px rgba(241, 196, 15, 0.14);
}

.floatingContact .contact-button:active {
  transform: translateY(0);
}

.floatingContact .contact-button:focus-visible {
  outline: 3px solid #f1c40f;
  outline-offset: 2px;
}

@media (prefers-reduced-motion: reduce) {
  .floatingContact .contact-button {
    transition: none;
    animation: none;
  }
}

@keyframes ctaAttention {
  0%, 72%, 100% {
    box-shadow: 0 10px 24px rgba(0, 0, 0, 0.4), 0 0 0 0 rgba(241, 196, 15, 0.55);
    transform: translateY(0);
  }
  10% {
    box-shadow: 0 12px 28px rgba(0, 0, 0, 0.45), 0 0 0 10px rgba(241, 196, 15, 0);
    transform: translateY(-1px);
  }
  18% {
    box-shadow: 0 12px 28px rgba(0, 0, 0, 0.45), 0 0 0 8px rgba(241, 196, 15, 0);
    transform: translateY(0);
  }
}

/* Make footer transparent to show gradient background */
.HomePage :deep(.footer) {
  background: transparent !important;
  background-image: none !important;
}

.HomePage ::v-deep .footer {
  background: transparent !important;
  background-image: none !important;
}

.main-content-wrapper .footer {
  background: transparent !important;
  background-image: none !important;
}

 
 </style>